<template>
  <vuex-table
    :fields="fields"
    :from_first_page="true"
    table_store="db/databases/table"
    table_class="databases-table"
  >
    <template slot="name" slot-scope="{ item }">
      <router-link :to="{ name: 'db.database.edit', params: { id: item.id } }">
        {{ item.name }}
      </router-link>
    </template>

    <template #state="{ item }">
      <state-badge :value="item.state" />
    </template>

    <template #database_group="{ item }">
      <template v-if="item.database_group">
        {{ item.database_group.name }}
      </template>
    </template>

    <template #actions="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>

        <router-link
          :to="{ name: 'db.database.recipient.create', params: { database_id: item.id } }"
          class="dropdown-item-icon dropdown-item-icon--user"
        >
          {{ $t('db.database.table.action.add_contact') }}
        </router-link>

        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import { DataBaseModalService } from '@db/modals/DataBaseModalService';
  import StateBadge from '@db/components/db/db-state-badge';

  export default {
    components: {
      StateBadge
    },
    data() {
      return {
        firstPage: false
      };
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'databases-table__name'
          },

          {
            key: 'state',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            class: 'databases-table__status'
          },

          {
            key: 'recipients_count',
            label: this.$t('db.database.field.recipients'),
            sortable: false,
            class: 'databases-table__recipients'
          },

          {
            key: 'database_group',
            label: this.$t('db.database.field.group'),
            sortable: false,
            class: 'databases-table__group'
          },

          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'table-created_at'
          },

          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('db/databases/table', ['getAsyncData']),

      remove: function (item) {
        DataBaseModalService.remove(item.id, item).on('success', () => this.getAsyncData({ current_page: 1 }));
      },

      edit: function (item) {
        DataBaseModalService.edit(item.id, item).on('success', () => this.getAsyncData({ current_page: 1 }));
      }
    }
  };
</script>

<style lang="scss">
  .databases-table {
    &__name {
      width: 100%;
    }

    &__recipients,
    &__status {
      min-width: 130px;
      max-width: 130px;
    }

    &__group {
      min-width: 150px;
    }
  }
</style>
